import React from 'react';
import { useUser, SignInButton } from '@clerk/clerk-react';

interface NavbarProps {
  onVisionClick?: () => void;
}

const LOGO_SVG = (
  <div className="flex items-center gap-4">
    <div className="flex flex-col leading-none">
      <span className="text-2xl font-black tracking-tighter text-white uppercase leading-[0.75]">
        NEOPAWN
      </span>
      <span className="text-[11px] font-bold tracking-[0.3em] text-white/50 uppercase mt-1">
        .com
      </span>
    </div>
  </div>
);

const Navbar: React.FC<NavbarProps> = ({ onVisionClick }) => {
  const { user, isLoaded } = useUser();

  return (
    <>
      {/* Global Banner */}
      <div className="w-full py-2.5 bg-black border-b border-white/5 text-[10px] sm:text-[11px] text-center text-white/40 font-bold uppercase tracking-[0.2em] px-4 relative z-50">
        NeoPawn Mainnet v2.4 · 
        <button className="underline hover:text-white transition-colors ml-1">
          Access Nodes →
        </button>
      </div>

      {/* Main Navbar */}
      <nav className="w-full h-16 px-4 sm:px-8 lg:px-12 flex justify-between items-center transition-all relative z-[60] bg-black border-b border-white/5">
        {/* Logo - Left aligned */}
        <div className="cursor-pointer hover:opacity-80 transition-opacity">
          {LOGO_SVG}
        </div>

        {/* Right side - Vision + Try Now buttons always together */}
        <div className="flex items-center gap-2 sm:gap-3">
          {onVisionClick && (
            <button
              onClick={onVisionClick}
              className="bg-white/10 border border-white/20 text-white px-3.5 sm:px-5 py-1.5 font-semibold hover:bg-white/20 active:scale-95 transition-all text-[10px] sm:text-[11px] rounded-[3px]"
            >
              Vision
            </button>
          )}

          {!user && isLoaded && (
            <SignInButton mode="modal">
              <button className="bg-white text-black px-3.5 sm:px-5 py-1.5 font-semibold hover:bg-white/90 transition-all text-[10px] sm:text-[11px] rounded-[3px] active:scale-95">
                Try Now
              </button>
            </SignInButton>
          )}

          {user && (
            <a
              href="/dashboard"
              className="bg-white text-black px-3.5 sm:px-5 py-1.5 font-semibold hover:bg-white/90 transition-all text-[10px] sm:text-[11px] rounded-[3px] active:scale-95 inline-block"
            >
              Dashboard
            </a>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
